import type { ClipboardEvent, KeyboardEvent } from 'react';

import isHotkey from 'is-hotkey';
import { Transforms } from 'slate';
import type { Descendant, Editor } from 'slate';

import { getIOSRedoUndoHandler, getIsContentChange } from '@flow/libs/editor/rich-text';

import { HOTKEYS, KEY_ENTER } from '../constants';
import { toggleMark } from './mark-utils';

export const createOnDOMBeforeInput = (editor: Editor) => getIOSRedoUndoHandler(editor);

const handleOnEnter = (editor: Editor, event: KeyboardEvent) => {
  if (event.key !== KEY_ENTER) {
    return;
  }

  if (event.shiftKey) {
    event.preventDefault();
    editor.insertText('\n');
  }

  event.stopPropagation();
};

export const createOnKeyDown = (editor: Editor) => (event: KeyboardEvent) => {
  handleOnEnter(editor, event);

  HOTKEYS.forEach(([hotkey, mark]) => {
    if (!isHotkey(hotkey, event)) {
      return;
    }

    event.preventDefault();
    toggleMark(editor, mark);
  });
};

export const createOnPaste = (editor: Editor) => (event: ClipboardEvent) => {
  event.preventDefault();

  const { clipboardData } = event;
  const plainText = clipboardData.getData('text/plain');

  Transforms.insertText(editor, plainText);
};

export const createOnSlateChange =
  (editor: Editor, onNodesChange: (nodes: Descendant[]) => void) => (nodes: Descendant[]) => {
    const isContentChange = getIsContentChange(editor);

    if (!isContentChange) {
      return;
    }

    onNodesChange(nodes);
  };
